import CheckIcon from '@mui/icons-material/Check';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Button,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container, Stack } from '@mui/system';
import React, { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import Carousel from 'react-material-ui-carousel';
import { setInterval } from 'timers';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import ExitPopupWagesTax from '@/components/ui/ExitPopupWagesTax';
import PricingDetailsInfoWage from '@/components/ui/PricingDetailsInfoWage';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

const WageTaxForms = () => {
  // const [open, setOpen] = useState(false);
  const [isPriceView1099s, setIsPriceView1099s] = React.useState(false);
  const images = [
    {
      label: (
        <React.Fragment>
          I am very happy with TaxZerone’s filing service. I was able to file
          multiple forms at once without any difficulties. Highly recommend for
          businesses!
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
          <Typography
            variant="body1"
            sx={{ mt: 2, textAlign: 'right', fontWeight: 600 }}
          >
            - Austin Wright{' '}
          </Typography>
        </React.Fragment>
      ),
    },
    {
      label: (
        <React.Fragment>
          Super easy to navigate and seeing the actual Fed forms helps with
          filling things out since I have done them manually for years. Thanks!
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
          <Typography
            variant="body1"
            sx={{ mt: 2, textAlign: 'right', fontWeight: 600 }}
          >
            - Avery Collins
          </Typography>
        </React.Fragment>
      ),
    },
    {
      label: (
        <React.Fragment>
          I’ve filed wage tax forms through other providers before, but
          TaxZerone is by far the most affordable and user-friendly. It saved me
          both time and money!
          <Stack
            direction="row"
            spacing={1}
            sx={{ mt: 2 }}
            justifyContent={{ xs: 'center', md: 'center' }}
          >
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-1"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-2"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-3"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-4"
            />
            <img
              src="/assets/images/star-icon.svg"
              width={18}
              height={17}
              alt="star-5"
            />
          </Stack>
          <Typography
            variant="body1"
            sx={{ mt: 2, textAlign: 'right', fontWeight: 600 }}
          >
            - Savannah Clarke
          </Typography>
        </React.Fragment>
      ),
    },
  ];

  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 2, 2));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 2, 2)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);

  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Days</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };
  return (
    <AppLayout
      meta={
        <Meta
          title="E-File Wage Tax Forms W-2 and W-2C using TaxZerone"
          description="File your W-2 & W-2c online with TaxZerone. Enjoy simple, secure, and affordable e-filing with transparent pricing and instant IRS filing confirmation."
          keywords=""
          canonical="wage-tax-forms/"
          jsonLdPricing="2.49"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <ExitPopupWagesTax
        isPriceView1099s={isPriceView1099s}
        setIsPriceView1099s={setIsPriceView1099s}
      />
      <InformationSubMenu />
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background:
              'linear-gradient(275deg,rgba(79, 69, 27, 1) 0%, rgba(48, 35, 102, 1) 100%)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18, lg: '1.20rem' },
                color: '#ccc',
                lineHeight: 1.3,
              }}
            >
              <strong>📢 Deadline passed! </strong> E-file your{' '}
              <b style={{ fontWeight: 600, color: '#efd6ac' }}>
                2025 W-2 Forms
              </b>{' '}
              now to minimize IRS penalties!
            </Typography>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Time left to file before the deadline{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  Feb 02, 2026
                </span>
                ):
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>
            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=wagestax`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                E-File Now
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>

      <Box sx={{ maxWidth: 1920, mx: 'auto' }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File{' '}
                <span className="highlight-container">
                  <span className="highlight">W-2 & W-2c</span>
                </span>{' '}
                Forms Online for the 2025 Tax Year
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                File your wage tax forms, such as W-2 and W-2c using TaxZerone
                to stay IRS compliant and avoid costly penalties.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Button
                  variant="contained"
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=wagestax`}
                  sx={{
                    mr: { xs: 0, md: 4 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                >
                  Get Started Now
                </Button>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>

              <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={0}
                m={0}
                mt={{ xs: 2, md: 5 }}
                pb={0}
                textAlign="center"
                sx={{ ml: { xs: 0, md: -5 } }}
              >
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/secure-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/secure-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/secure-new-icon.png"
                          alt="Safe & Secure"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Safe &
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Secure
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 2,
                      borderRadius: 4,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/irs-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/irs-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/irs-new-icon.png"
                          alt="IRS Authorized"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      IRS
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Authorized
                    </strong>
                  </Paper>
                </Grid>
                <Grid size={4}>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: { xs: 1, sm: 2 },
                      borderRadius: 0,
                      borderWidth: 0,
                      fontSize: { xs: 9, sm: 12, lg: 13 },
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#efefef',
                        borderRadius: '50%',
                        width: { xs: 40, sm: 70 },
                        height: { xs: 40, sm: 70 },
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        mx: 'auto',
                        mb: { xs: 0.5, sm: 1 },
                        p: { xs: 1, sm: 2 },
                        textAlign: 'center',
                      }}
                    >
                      <picture style={{ width: '100%', height: '100%' }}>
                        <source
                          srcSet="/assets/images/lowest-new-icon.webp"
                          width="100%"
                          height="100%"
                        />
                        <source
                          srcSet="/assets/images/lowest-new-icon.png"
                          width="100%"
                          height="100%"
                        />
                        <img
                          src="/assets/images/lowest-new-icon.png"
                          alt="Affordable Price"
                          loading="lazy"
                          width="100%"
                          height="100%"
                        />
                      </picture>
                    </Box>
                    <strong>
                      Affordable
                      <Hidden lgUp mdDown>
                        <br />
                      </Hidden>{' '}
                      Filing Fee
                    </strong>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Hidden lgDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              className="form-wages-tax"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/wages-tax-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/wages-tax-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/wages-tax-landing-img.png"
                  alt="E-File W-2 & W-2c Forms Online for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden lgUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              className="form-wages-tax"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/wages-tax-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/wages-tax-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/wages-tax-landing-img-sm.png"
                  alt="E-File W-2 & W-2c Forms Online for the 2025 Tax Year"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 3 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <PricingDetailsInfoWage
                formName="Wages Tax Forms"
                colorCode="#4269e2"
              />{' '}
              <Typography variant="body1" sx={{ mb: 2, textAlign: 'right' }}>
                <Link
                  sx={{ color: '#0202ff', cursor: 'pointer' }}
                  onClick={() => setIsPriceView1099s(true)}
                >
                  How TaxZerone’s Pricing Works?
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          mb: 4,
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 3 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Pricing Includes
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 4, md: 5 }}
              textAlign="center"
              sx={{
                display: 'flex',
                alignSelf: 'end',
                alignItems: 'flex-end',
                placeContent: { sm: 'end', xs: 'center' },
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  backgroundColor: '#f0f2f9',
                  p: 2,
                  borderRadius: 3,
                  minHeight: '100%',

                  textAlign: 'left',

                  maxWidth: 400,
                }}
              >
                <Stack spacing={1} direction="column">
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Bulk Filing{' '}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Schedule Filing
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Transmittal Form W-3
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      USPS Address Validation
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Error Checks
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'grid',
                      columnGap: 1,
                      gridTemplateColumns: 'auto auto ',
                      textAlign: 'left',
                      placeContent: 'start',
                    }}
                  >
                    <Box>
                      <CheckIcon sx={{ color: '#1da94a' }} />
                    </Box>
                    <Typography variant="body1" sx={{ fontWeight: 500 }}>
                      Expert Support
                    </Typography>
                  </Box>
                </Stack>
              </Paper>
            </Grid>

            <Grid
              size={{ xs: 12, sm: 8, md: 7 }}
              sx={{
                mt: 0,
                textAlign: 'center',
                justifyContent: 'center',
                alignSelf: 'start',
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { md: 22, sm: 20, xs: 18 },
                  textAlign: 'center',
                  fontWeight: 600,
                  mt: 0,
                  mb: 1,
                }}
              >
                Add-ons Available{' '}
              </Typography>
              <Box sx={{ mb: 5, maxWidth: 600, m: 'auto' }}>
                <TableContainer
                  sx={{ border: '1px solid #828282', borderRadius: 1 }}
                >
                  <Table aria-label="EFW Individual">
                    <TableHead>
                      {/* <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          Aspect
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          IRP (International Registration Plan)
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            fontWeight: 600,
                            width: 300,
                          }}
                        >
                          IFTA (International Fuel Tax Agreement)
                        </TableCell>
                      </TableRow> */}
                    </TableHead>
                    <TableBody>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell sx={{ fontWeight: 600 }}>
                          State Filing{' '}
                        </TableCell>
                        <TableCell>
                          <span
                            style={{
                              fontWeight: 700,
                              color: '#4269e2',
                              fontSize: 20,
                            }}
                          >
                            $ 0.99
                          </span>
                          /form
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Electronic Delivery
                        </TableCell>
                        <TableCell>
                          <span
                            style={{
                              fontWeight: 700,
                              color: '#4269e2',
                              fontSize: 20,
                            }}
                          >
                            $ 0.50
                          </span>
                          /form
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Postal Mailing
                        </TableCell>
                        <TableCell>
                          <span
                            style={{
                              fontWeight: 700,
                              color: '#4269e2',
                              fontSize: 20,
                            }}
                          >
                            $1.75
                          </span>
                          /form
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: { md: 8, sm: 4, xs: 3 } }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                E-File Wage Tax Forms with TaxZerone
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 6 }}
              textAlign="right"
              sx={{
                rowGap: 1,
                position: 'relative',
                // maxWidth: '450px',
                display: 'flex',
                justifyContent: 'right',
                m: 'auto',
                alignContent: 'right',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  maxWidth: '363px',
                  borderWidth: 2,
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#faedcd',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-w2/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/wages-tax-img.webp" />
                      <source srcSet="/assets/images/wages-tax-img.png" />
                      <img
                        src="/assets/images/wages-tax-img.png"
                        alt="Wage and Tax Statement"
                        className="partner-card"
                        loading="lazy"
                        width={359}
                        height={262}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 1 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          textTransform: 'uppercase',
                        }}
                      >
                        Form W-2
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 1,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      Wage and Tax Statement
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)' }}
                    >
                      Report wages, salaries, and other compensation paid to
                      employees, along with federal, state, and other taxes
                      withheld.
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=wagestax`}
                  >
                    E-File W-2
                  </Button>
                </Box>
              </Paper>
            </Grid>

            <Grid
              size={{ xs: 12, sm: 6, md: 6 }}
              textAlign="left"
              sx={{
                rowGap: 1,
                position: 'relative',
                maxWidth: '450px',
                alignContent: 'right',
                display: 'flex',
                justifyContent: 'left',
              }}
            >
              <Paper
                variant="outlined"
                sx={{
                  borderRadius: 3,
                  minHeight: '100%',
                  position: 'relative',
                  borderWidth: 2,
                  maxWidth: '363px',
                  transition: 'all 0.5s ease 0s',
                  '&:hover, &:focus, &:active': {
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
                    borderColor: '#989898',
                  },
                  '&:hover h3': { color: '#4269e2' },
                  '&:hover .MuiTypography-body2 ': {
                    backgroundColor: '#4a5759',
                    color: '#fff',
                  },
                }}
              >
                {' '}
                <Link
                  href="/information-returns/efile-irs-form-w2-c/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mb: 0,
                      borderTopRightRadius: 16,
                      borderTopLeftRadius: 12,
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/correction-wages-tax-img.webp" />
                      <source srcSet="/assets/images/correction-wages-tax-img.png" />
                      <img
                        src="/assets/images/correction-wages-tax-img.png"
                        alt="Corrected Wage and Tax Statement"
                        className="partner-card"
                        loading="lazy"
                        width={359}
                        height={262}
                        style={{
                          borderTopRightRadius: 12,
                          borderTopLeftRadius: 12,
                        }}
                      />
                    </picture>
                  </Box>
                  <Box sx={{ p: 2.8, textAlign: 'left', mb: 1 }}>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 1,
                        textAlign: 'left',
                        position: 'absolute',
                        top: 16,
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          p: 0,
                          backgroundColor: '#fff',
                          display: 'flex',
                          boxAlign: 'center',
                          alignItems: 'center',
                          borderRadius: 3,
                          fontWeight: 700,
                          color: '#0d1b2a',
                          px: 1,
                          py: 0.5,
                          // textTransform: 'uppercase',
                        }}
                      >
                        FORM W-2c
                      </Typography>
                    </Box>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { md: 20, sm: 18, xs: 16 },
                        fontWeight: 600,
                        textAlign: 'left',
                        mb: 1,
                        mt: 1,
                        color: 'rgb(68, 68, 68)',
                      }}
                    >
                      Corrected Wage and Tax Statement
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ color: 'rgb(68, 68, 68)' }}
                    >
                      Correct errors on a previously filed{' '}
                      <Hidden smDown>
                        {' '}
                        <br />
                      </Hidden>
                      <span style={{ fontWeight: 600 }}>W-2</span>, such as
                      incorrect wages, withholding, or personal information.
                    </Typography>
                  </Box>
                </Link>
                <Box sx={{ textAlign: 'center', mb: 3 }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      textTransform: 'none',
                      borderRadius: 4,
                      boxShadow: 'none',
                      px: 3,
                      fontSize: { xs: 16, sm: 18, md: 20 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                        boxShadow: 'none',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=wagestax`}
                  >
                    E-File W-2c
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction={{ xs: 'column-reverse', sm: 'row' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'center',
                }}
              >
                Who Should File Wage Tax Forms?
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 1.5,
                  borderRadius: 4,
                  backgroundColor: 'rgba(230, 242, 255, 0.6)',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    textAlign: 'center',
                    backgroundColor: '#fff',
                    fontSize: { md: 14, sm: 14, xs: 14 },
                    color: '#001a2c',
                    fontWeight: 600,
                    p: '3px 10px',
                    borderRadius: 3,
                    display: 'flex',
                    alignContent: 'center',
                    justifyContent: 'center',
                    width: 'fit-content',
                    my: 2,
                  }}
                >
                  Form W-2
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 3 },
                    mb: { xs: 0, sm: 7, md: 0 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Any business, organization, or individual that pays wages
                      and withheld federal income tax, Social Security, or
                      Medicare taxes
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Household Employers paying workers of $2,700 or more
                      annually.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Employers providing employees with taxable fringe
                      benefits.
                    </Box>
                  </li>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 1.5,
                  borderRadius: 4,
                  backgroundColor: 'rgba(201, 228, 202, 0.6)',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    textAlign: 'center',
                    backgroundColor: '#fff',
                    fontSize: { md: 14, sm: 14, xs: 14 },
                    color: '#04471c',
                    fontWeight: 600,
                    p: '3px 10px',
                    borderRadius: 3,
                    display: 'flex',
                    alignContent: 'center',
                    justifyContent: 'center',
                    width: 'fit-content',
                    my: 2,
                  }}
                >
                  Form W-2C
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    listStyleType: 'none',
                    paddingLeft: 0,
                    textAlign: 'left',
                    ml: { xs: 0, sm: 3 },
                    mt: { xs: 0, md: 3 },
                    mb: { xs: 0, md: 0 },
                    '& li': { display: 'flex' },
                  }}
                >
                  {' '}
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Employer Errors in Original W-2 such as incorrect employee
                      name, SSN, EIN, wrong wage, tip, or errors in tax
                      withholding amounts
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      Incorrect reporting of retirement plan contributions,
                      dependent care benefits, or other fringe benefits.
                    </Box>
                  </li>
                  <li
                    style={{
                      marginBottom: 10,
                    }}
                  >
                    <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                    <Box>
                      If payroll records are updated or corrected after the
                      original W-2 was filed.
                    </Box>
                  </li>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction={{ xs: 'column-reverse', sm: 'row' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, sm: 6, md: 6 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 1,
                  textAlign: 'left',
                }}
              >
                Why File Wage Tax Forms?
              </Typography>

              <Box
                component="ul"
                sx={{
                  listStyleType: 'none',
                  paddingLeft: 0,
                  textAlign: 'left',
                  ml: { xs: 0, sm: 3 },
                  mt: { xs: 0, md: 3 },
                  mb: { xs: 0, md: 3 },
                  '& li': { display: 'flex' },
                }}
              >
                {' '}
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    Wage tax forms confirm that withheld taxes have been
                    reported correctly.
                  </Box>
                </li>
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    Employees rely on wage tax forms like Form W-2 to file their
                    own income tax returns
                  </Box>
                </li>
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    Filing timely and accurate wage tax forms shows
                    professionalism and builds trust with employees and
                    authorities.
                  </Box>
                </li>
                <li
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <CheckCircleRoundedIcon sx={{ color: '#1da94a', mr: 1 }} />{' '}
                  <Box>
                    Filing helps you stay compliant at both federal and state
                    levels.
                  </Box>
                </li>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }} sx={{ position: 'relative' }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/wages-tax-why-img.webp" />
                  <source srcSet="/assets/images/wages-tax-why-img.png" />
                  <img
                    src="/assets/images/wages-tax-why-img.png"
                    alt="Why File Wage Tax Forms?  "
                    className="img-responsive"
                    loading="lazy"
                    width={550}
                    height={550}
                  />
                </picture>
              </Box>
              {/* <Hidden mdDown>
                <Box
                  sx={{
                    position: 'absolute',
                    width: { lg: 240, md: 230 },
                    alignSelf: 'center',
                    maxWidth: '100%',
                    height: 80,
                    background: 'rgba(255, 255, 255, 0.06)',
                    backdropFilter: 'blur(16px)',
                    borderRadius: 4,
                    boxShadow:
                      '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 0 0px 0px rgba(255, 255, 255, 0)',
                    overflow: 'hidden',
                    top: { ld: 40, md: 0 },
                    right: { lg: 430, md: 290, sm: 360 },

                    '&:before': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      background:
                        'linear-gradient( 90deg,  transparent, rgba(255, 255, 255, 0.8), transparent)',
                    },
                    '&:after': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      height: '100%',
                      background:
                        'linear-gradient( 180deg,  transparent, rgba(255, 255, 255, 0.8), transparent, rgba(255, 255, 255, 0.3))',
                    },
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      justifyContent: 'center',
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/accurate-records-icon.webp" />
                      <source srcSet="/assets/images/accurate-records-icon.png" />
                      <img
                        src="/assets/images/accurate-records-icon.png"
                        alt="Maintain Accurate Records"
                        // className="img-responsive"
                        loading="lazy"
                        width={50}
                        height={50}
                      />
                    </picture>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { lg: 16, md: 15 },
                        alignContent: 'center',
                        textAlign: 'center',
                      }}
                    >
                      Accurate Records
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    width: { lg: 240, md: 240, sm: 180 },
                    alignSelf: 'center',

                    height: 80,
                    background: 'rgba(255, 255, 255, 0.06)',
                    backdropFilter: 'blur(16px)',
                    borderRadius: 4,
                    boxShadow:
                      '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 0 0px 0px rgba(255, 255, 255, 0)',
                    overflow: 'hidden',
                    bottom: { lg: 160, md: 0 },
                    right: { lg: 390, md: 270 },

                    '&:before': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      background:
                        'linear-gradient( 90deg,  transparent, rgba(255, 255, 255, 0.8), transparent)',
                    },
                    '&:after': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      height: '100%',
                      background:
                        'linear-gradient( 180deg,  transparent, rgba(255, 255, 255, 0.8), transparent, rgba(255, 255, 255, 0.3))',
                    },
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      justifyContent: 'center',
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/build-trust-icon.webp" />
                      <source srcSet="/assets/images/build-trust-icon.png" />
                      <img
                        src="/assets/images/build-trust-icon.png"
                        alt="Build Trust & Credibility"
                        // className="img-responsive"
                        loading="lazy"
                        width={50}
                        height={50}
                      />
                    </picture>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { lg: 16, md: 15 },
                        alignContent: 'center',
                        textAlign: 'left',
                      }}
                    >
                      Build Trust & Credibility
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    position: 'absolute',
                    width: { lg: 240, md: 200 },
                    alignSelf: 'center',

                    height: 80,
                    background: 'rgba(255, 255, 255, 0.06)',
                    backdropFilter: 'blur(16px)',
                    borderRadius: 4,
                    boxShadow:
                      '0 8px 32px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.5), inset 0 -1px 0 rgba(255, 255, 255, 0.1), inset 0 0 0px 0px rgba(255, 255, 255, 0)',
                    overflow: 'hidden',
                    top: { lg: 150, md: 300 },
                    left: { lg: 350, md: 370 },

                    '&:before': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      background:
                        'linear-gradient( 90deg,  transparent, rgba(255, 255, 255, 0.8), transparent)',
                    },
                    '&:after': {
                      // content: '',
                      position: 'absolute',
                      top: 0,
                      height: '100%',
                      background:
                        'linear-gradient( 180deg,  transparent, rgba(255, 255, 255, 0.8), transparent, rgba(255, 255, 255, 0.3))',
                    },
                  }}
                >
                  <Box
                    sx={{
                      p: 2,
                      display: 'flex',
                      gridTemplateColumns: 'auto auto ',
                      columnGap: 1,
                      placeContent: 'start',
                      justifyContent: 'center',
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/audit-risks-icon.webp" />
                      <source srcSet="/assets/images/audit-risks-icon.png" />
                      <img
                        src="/assets/images/audit-risks-icon.png"
                        alt="Audit Risks"
                        // className="img-responsive"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: 600,
                        fontSize: { md: 16, sm: 17, xs: 16 },
                        alignContent: 'center',
                        textAlign: 'left',
                      }}
                    >
                      Reduce Audit Risks
                    </Typography>
                  </Box>
                </Box>
              </Hidden> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 }, mb: 2 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 0,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                How to E-File Wage Tax Forms using TaxZerone?
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/wages-tax-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/wages-tax-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/wages-tax-steps-img.png"
                  alt="How to E-File Wage Tax Forms using TaxZerone?"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                m: '0',
                textAlign: { xs: 'center', md: 'left' },
              }}
            >
              {/* <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                }}
              >
                How it works:
              </Typography> */}
              <Box>
                <Box
                  component="ol"
                  sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                      flex: 0,
                      padding: 0,
                    },
                    p: 2,
                    pl: 0,
                    ml: { xs: 0, sm: 0, md: -2 },
                  }}
                >
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          my: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source
                            srcSet="/assets/images/step-1-icon.webp"
                            width={39}
                            height={39}
                          />
                          <source
                            srcSet="/assets/images/step-1-icon.png"
                            width={39}
                            height={39}
                          />
                          <img
                            src="/assets/images/step-1-icon.png"
                            alt="Enter all the required fields"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography variant="body1">
                        <b>Enter all the required fields </b> <br />
                        Enter the required details for the chosen form type.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          m: 0,
                          mt: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source srcSet="/assets/images/step-2-icon.webp" />
                          <source srcSet="/assets/images/step-2-icon.png" />
                          <img
                            src="/assets/images/step-2-icon.png"
                            alt=" Transmit to the IRS"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent sx={{ mb: 2 }}>
                      <Typography variant="body1">
                        <b> Transmit to the IRS </b> <br />
                        Review and transmit your return to the IRS.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                  <TimelineItem>
                    <TimelineSeparator>
                      <TimelineDot
                        sx={{
                          backgroundColor: 'transparent',
                          boxShadow: 'none',
                          mt: -1,
                          mb: -1.7,
                        }}
                      >
                        <picture>
                          <source srcSet="/assets/images/step-3-icon.webp" />
                          <source srcSet="/assets/images/step-3-icon.png" />
                          <img
                            src="/assets/images/step-3-icon.png"
                            alt="Send Recipient’s Copy"
                            loading="lazy"
                            width={39}
                            height={39}
                          />
                        </picture>
                      </TimelineDot>
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography variant="body1">
                        <b>Send Recipient’s Copy </b> <br />
                        Deliver your recipient’s copy through ZeroneVault or
                        postal mailing.
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                </Box>
                <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                  <Button
                    variant="contained"
                    sx={{
                      mt: { xs: 2, sm: 4 },
                      mb: { xs: 2, sm: 2, md: 5 },
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=wagestax`}
                  >
                    E-File Now
                  </Button>
                </Box>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Benefits of E-filing Wage Tax forms with TaxZerone?
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone simplifies information return filing with these
                amazing features
              </Typography> */}
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS Authorized"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS Authorized
                </Typography>
                <Typography variant="body1">
                  TaxZerone is an IRS-authorized e-file provider. We ensure your
                  wage tax forms (W-2 or W-2c) are filed accurately and securely
                  with the IRS.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Bulk Upload"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Bulk Upload
                </Typography>
                <Typography variant="body1">
                  Quickly upload and file multiple wage tax forms simultaneously
                  with TaxZerone, which will save you time and make the e-filing
                  easier.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Share Employee Copies"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Share Employee Copies
                </Typography>
                <Typography variant="body1">
                  TaxZerone helps you to share the employee copies - either
                  instantly through{' '}
                  <Link
                    href="https://taxzerone.zeronevault.com/"
                    sx={{ color: '#0202ff' }}
                  >
                    ZeroneVault
                  </Link>{' '}
                  or by sending them right to their mailbox.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/state-file-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/state-file-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/state-file-icon.png"
                      alt="State Filing Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  State Filing Support
                </Typography>
                <Typography variant="body1">
                  You can file both your federal and state returns using
                  TaxZerone. We ensure that you stay compliant with specific
                  state requirements while also meeting federal regulations.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/time-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/time-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/time-icon.png"
                      alt="Real-Time Updates"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Real-Time Updates
                </Typography>
                <Typography variant="body1">
                  TaxZerone keeps you informed at every stage from filing your
                  wage tax forms to IRS acceptance by sending timely email
                  updates straight to your inbox.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-based-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-based-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-based-icon.png"
                      alt="Schedule Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Schedule Filing
                </Typography>
                <Typography variant="body1">
                  With our schedule filing feature, you can prepare your wage
                  tax forms in advance and select the exact date you want your
                  return to be submitted to the IRS.
                </Typography>
              </Paper>
            </Grid>

            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',

                  borderColor: '#8492c0',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Affordable Pricing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Affordable Pricing
                </Typography>
                <Typography variant="body1">
                  Whether you are filing single or multiple wage tax forms,
                  TaxZerone offers affordable pricing in the industry.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,

                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/filling-requiremnt-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/filling-requiremnt-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/filling-requiremnt-icon.png"
                      alt="Smart Validation System"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Smart Validation System
                </Typography>
                <Typography variant="body1">
                  Ensure your W2 and W-2c forms meet SSA standards with our
                  advanced validation system, which will minimize errors and
                  avoid costly rejections.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Expert Support "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Expert Support
                </Typography>
                <Typography variant="body1">
                  <span style={{ fontWeight: 600 }}> Have questions?</span> Our
                  friendly support team is ready to help you via email, phone
                  (in English or Spanish), and live chat.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
        <Grid
          container
          spacing={2}
          m={2}
          mt={{ xs: 5, sm: 5, md: 10 }}
          mb={{ xs: 5, sm: 5, md: 10 }}
          className="MuiGrid-root-width"
        >
          <Grid size={12} textAlign="center">
            <Stack
              direction="row"
              spacing={1}
              sx={{ mb: 2 }}
              justifyContent={{ xs: 'center', md: 'center' }}
            >
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-1"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-2"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-3"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-4"
              />
              <img
                src="/assets/images/star-icon.svg"
                width={30}
                height={28}
                alt="star-5"
              />
            </Stack>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: { xs: 1, sm: 3 },
              }}
            >
              Hear What Our Clients Say About Us
            </Typography>

            <Carousel
              animation="fade"
              navButtonsAlwaysVisible
              indicatorIconButtonProps={{
                style: {
                  marginTop: '0px', // 5
                  textAlign: 'right', // 4
                  paddingBottom: '0px',
                  marginBottom: '0px',
                },
              }}
              className="carousel"
            >
              {images.map((step, index) => (
                <Box
                  component="div"
                  sx={{
                    p: 2,
                    textAlign: 'center',

                    borderRadius: 0,
                    backgroundColor: 'transparent',
                    borderWidth: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    mx: { xs: -2, sm: 'auto' },
                    maxWidth: 800,
                    minHeight: { xs: 200, sm: 170, md: 220 },
                  }}
                  key={index}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: 'san-serif',
                      fontSize: { xs: 65, sm: 100 },
                      fontWeight: 600,
                      color: '#1da94a',
                      lineHeight: { xs: '30px', sm: '65px' },
                    }}
                  >
                    &ldquo;
                  </Typography>
                  <Typography
                    variant="body1"
                    component="div"
                    color="gray"
                    sx={{
                      fontSize: { xs: 18, sm: 22, md: 30 },
                      fontFamily: 'san-serif',
                      fontStyle: 'italic',
                      color: '#414042',
                      lineHeight: 1.2,
                    }}
                  >
                    {step.label}
                  </Typography>
                  <Typography
                    component="span"
                    sx={{
                      fontFamily: 'san-serif',
                      fontSize: { xs: 65, sm: 100 },
                      fontWeight: 600,
                      color: '#1da94a',
                      lineHeight: { xs: '30px', sm: '65px' },
                    }}
                  >
                    &rdquo;
                  </Typography>
                </Box>
              ))}
            </Carousel>
          </Grid>
        </Grid>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            // direction={{ xs: 'column-reverse', sm: 'row' }}
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Common Use Cases
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 6 }} sx={{ minHeight: '100%' }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 1,
                  borderRadius: 4,
                  backgroundColor: '#fff',
                  minWidth: '100%',

                  '&:hover': {
                    boxShadow:
                      '0px 18px 36px -18px rgba(0,0,0,0.1), 0px 30px 45px -30px rgba(50,50,93,0.25)',
                  },
                  '&:hover .card-gradient': {
                    transform: 'translateY(-42px)',
                    opacity: 0.5,
                    filter: ' blur(20px)',
                  },
                  '&:hover .card-text': {
                    backgroundColor: '#fff',
                    transform: 'translateY(-22px) !important ',
                    willChange: 'transform',
                  },
                }}
              >
                <Box
                  sx={{
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    aspectRatio: 1.5,
                    backgroundColor: '#f6f9fc',
                    overflow: 'hidden',
                    position: 'relative',
                    minWidth: '100%',
                    minHeight: 72,

                    transition: 'transform 300ms cubic-bezier(0.33,1,0.68,1)',

                    // '&:hover': {
                    //   transform: 'translateY(-12px)',
                    //   boxShadow:
                    //     '0px 18px 36px -18px rgba(0,0,0,0.1), 0px 30px 45px -30px rgba(50,50,93,0.25)',
                    // },
                  }}
                >
                  <Box
                    className="card-gradient"
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      opacity: 0,
                      transform: 'translateY(30px)',
                      transition:
                        'transform 300ms cubic-bezier(0.33,1,0.68,1), opacity 300ms ease',
                      willChange: 'transform, opacity',
                      pointerEvents: 'none',
                    }}
                  >
                    <svg
                      width={600}
                      height={400}
                      viewBox="0 0 600 400"
                      fill="none"
                      className="card_gradientSvg"
                    >
                      <ellipse
                        className="Card-ellipse-one"
                        opacity={0.7}
                        cx="205.095"
                        cy="194.189"
                        rx="192.729"
                        ry="172.493"
                        transform="translate(305.095px, 294.189px) rotate(-41.7514deg) translate(-305.095px, -294.189px)"
                        fill="#223e99"
                        filter="url(#blurGlow)"
                      />

                      <ellipse
                        className="Card-ellipse-two"
                        opacity={0.6}
                        cx="314.947"
                        cy="183.229"
                        rx="214.947"
                        ry="183.229"
                        transform="matrix(0.8571 -0.51515 -0.51515 -0.8571 373.81 726)"
                        fill="#caf0f8"
                        filter="url(#blurGlow)"
                      />

                      <defs>
                        <filter
                          id="blurGlow"
                          x="-50%"
                          y="-50%"
                          width="200%"
                          height="200%"
                        >
                          <feGaussianBlur stdDeviation="40" />
                        </filter>
                        <radialGradient
                          id="card-paint-one"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(319.628 260.311) rotate(88.8263) scale(253.398 377.821)"
                        >
                          <stop offset="0.25" stopColor="#223e99" />
                          <stop
                            offset="0.744792"
                            stopColor="#caf0f8"
                            stopOpacity={0}
                          />
                        </radialGradient>

                        <radialGradient
                          id="card-paint-two"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(330.582 248.016) rotate(89.4327) scale(234.804 286.235)"
                        >
                          <stop stopColor="#223e99" />
                          <stop
                            offset="1"
                            stopColor="#caf0f8"
                            stopOpacity={0}
                          />
                        </radialGradient>
                      </defs>
                    </svg>
                  </Box>

                  <Box
                    sx={{
                      transform: 'scale(0.96124)',
                      // position: 'absolute',
                      top: 0,
                      left: 0,
                      // transformOrigin: 'top left',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        width: '100%',
                        height: '424px',
                        flexDirection: 'column',
                        insert: 0,
                        gap: 2,
                        alignItems: 'center',
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/common-use-w2-img.webp" />
                        <source srcSet="/assets/images/common-use-w2-img.png" />
                        <img
                          src="/assets/images/common-use-w2-img.png"
                          alt="Common Use Cases W-2"
                          className="responsive-img"
                          loading="lazy"
                          width={340}
                          height="auto"
                          style={{
                            border: '1px solid rgba(190, 190, 190, 0.3)',
                            borderRadius: 6,
                            aspectRatio: 'auto 480 / 296',
                          }}
                        />
                      </picture>
                      <picture>
                        <source srcSet="/assets/images/common-use-case-w2-img.webp" />
                        <source srcSet="/assets/images/common-use-case-w2-img.png" />
                        <img
                          src="/assets/images/common-use-case-w2-img.png"
                          alt="Common Use Cases W-2"
                          className="responsive-img"
                          loading="lazy"
                          width={340}
                          height="auto"
                          style={{
                            border: '1px solid rgba(190, 190, 190, 0.3)',
                            borderRadius: 6,

                            aspectRatio: 'auto 480 / 296',
                          }}
                        />
                      </picture>
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    p: 3,
                    transition: 'transform 300ms cubic-bezier(0.33,1,0.68,1)',
                  }}
                  className="card-text"
                >
                  <Typography
                    variant="body1"
                    sx={{
                      backgroundColor: '#caf0f8',
                      px: 1.5,
                      py: 0.6,
                      borderRadius: 6,
                      display: 'inline-flex',
                      fontWeight: 600,
                    }}
                  >
                    Form W-2
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 0 },
                      mt: { xs: 0, md: 3 },
                      mb: { xs: 0, md: 0 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    {' '}
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Reporting employee wages, tips, and other compensation.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Reporting federal income tax, Social Security, and
                        Medicare tax withheld.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Reporting state and local wages and taxes withheld.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Providing employees with necessary details to file their
                        personal tax returns.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 0,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Reporting taxable fringe benefits, retirement plan
                        contributions, and dependent care benefits.
                      </Box>
                    </li>
                  </Box>
                </Box>
              </Paper>
              {/* <Box
                component={'div'}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/w-2-usecases-img.webp" />
                  <source srcSet="/assets/images/w-2-usecases-img.png" />
                  <img
                    src="/assets/images/w-2-usecases-img.png"
                    alt="Common Use Cases"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                    style={{
                      border: '2px solid rgba(190, 190, 190, 0.3)',
                      borderRadius: 21,
                    }}
                  />
                </picture>
              </Box> */}
            </Grid>
            <Grid size={{ xs: 12, md: 6, sm: 6 }} sx={{ minHeight: '100%' }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 1,
                  borderRadius: 4,
                  backgroundColor: '#fff',
                  minWidth: '100%',

                  '&:hover': {
                    boxShadow:
                      '0px 18px 36px -18px rgba(0,0,0,0.1), 0px 30px 45px -30px rgba(50,50,93,0.25)',
                  },
                  '&:hover .card-gradient': {
                    transform: 'translateY(-42px)',
                    opacity: 0.5,
                    filter: ' blur(20px)',
                  },
                  '&:hover .card-text': {
                    backgroundColor: '#fff',
                    transform: 'translateY(-22px) !important ',
                    willChange: 'transform',
                  },
                }}
              >
                <Box
                  sx={{
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    aspectRatio: 1.5,
                    backgroundColor: '#f6f9fc',
                    overflow: 'hidden',
                    position: 'relative',
                    minWidth: '100%',
                    minHeight: 72,

                    transition: 'transform 300ms cubic-bezier(0.33,1,0.68,1)',

                    // '&:hover': {
                    //   transform: 'translateY(-12px)',
                    //   boxShadow:
                    //     '0px 18px 36px -18px rgba(0,0,0,0.1), 0px 30px 45px -30px rgba(50,50,93,0.25)',
                    // },
                  }}
                >
                  <Box
                    className="card-gradient"
                    sx={{
                      position: 'absolute',
                      inset: 0,
                      opacity: 0,
                      transform: 'translateY(30px)',
                      transition:
                        'transform 300ms cubic-bezier(0.33,1,0.68,1), opacity 300ms ease',
                      willChange: 'transform, opacity',
                      pointerEvents: 'none',
                    }}
                  >
                    <svg
                      width={600}
                      height={400}
                      viewBox="0 0 600 400"
                      fill="none"
                      className="card_gradientSvg"
                    >
                      <ellipse
                        className="Card-ellipse-one"
                        opacity={0.7}
                        cx="205.095"
                        cy="194.189"
                        rx="192.729"
                        ry="172.493"
                        transform="translate(305.095px, 294.189px) rotate(-41.7514deg) translate(-305.095px, -294.189px)"
                        fill="#223e99"
                        filter="url(#blurGlow)"
                      />

                      <ellipse
                        className="Card-ellipse-two"
                        opacity={0.6}
                        cx="314.947"
                        cy="183.229"
                        rx="214.947"
                        ry="183.229"
                        transform="matrix(0.8571 -0.51515 -0.51515 -0.8571 373.81 726)"
                        fill="#caf0f8"
                        filter="url(#blurGlow)"
                      />

                      <defs>
                        <filter
                          id="blurGlow"
                          x="-50%"
                          y="-50%"
                          width="200%"
                          height="200%"
                        >
                          <feGaussianBlur stdDeviation="40" />
                        </filter>
                        <radialGradient
                          id="card-paint-one"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(319.628 260.311) rotate(88.8263) scale(253.398 377.821)"
                        >
                          <stop offset="0.25" stopColor="#223e99" />
                          <stop
                            offset="0.744792"
                            stopColor="#caf0f8"
                            stopOpacity={0}
                          />
                        </radialGradient>

                        <radialGradient
                          id="card-paint-two"
                          gradientUnits="userSpaceOnUse"
                          gradientTransform="translate(330.582 248.016) rotate(89.4327) scale(234.804 286.235)"
                        >
                          <stop stopColor="#223e99" />
                          <stop
                            offset="1"
                            stopColor="#caf0f8"
                            stopOpacity={0}
                          />
                        </radialGradient>
                      </defs>
                    </svg>
                  </Box>

                  <Box
                    sx={{
                      transform: 'scale(0.96124)',
                      // position: 'absolute',
                      top: 0,
                      left: 1,
                      // transformOrigin: 'top left',
                    }}
                  >
                    <Box
                      sx={{
                        // display: 'flex',
                        width: '100%',
                        height: '424px',
                        flexDirection: 'column',
                        insert: 0,
                        gap: 2,
                        alignItems: 'center',
                        position: 'relative',
                        display: 'grid',
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/common-use-w2c-img.webp" />
                        <source srcSet="/assets/images/common-use-w2c-img.png" />
                        <img
                          src="/assets/images/common-use-w2c-img.png"
                          alt="Common Use Cases W-2C"
                          className="responsive-img"
                          loading="lazy"
                          width={340}
                          height="auto"
                          style={{
                            // border: '1px solid rgba(190, 190, 190, 0.3)',
                            borderRadius: 6,
                            top: 2,
                            position: 'absolute',
                            aspectRatio: 'auto 480 / 296',
                          }}
                        />
                      </picture>
                      <picture>
                        <source srcSet="/assets/images/case-use-w2c-img.webp" />
                        <source srcSet="/assets/images/case-use-w2c-img.png" />
                        <img
                          src="/assets/images/case-use-w2c-img.png"
                          alt="Common Use Cases W-2C"
                          className="responsive-img-card"
                          loading="lazy"
                          width={340}
                          height="auto"
                          style={{
                            // border: '1px solid rgba(190, 190, 190, 0.3)',
                            borderRadius: 6,
                            right: 11,
                            bottom: 1,

                            position: 'absolute',
                            aspectRatio: 'auto 480 / 296',
                          }}
                        />
                      </picture>
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    p: 3,
                    transition: 'transform 300ms cubic-bezier(0.33,1,0.68,1)',
                  }}
                  className="card-text"
                >
                  <Typography
                    variant="body1"
                    sx={{
                      backgroundColor: '#dde392',
                      px: 1.5,
                      py: 0.6,
                      borderRadius: 6,
                      display: 'inline-flex',
                      fontWeight: 600,
                    }}
                  >
                    Form W-2C
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 0 },
                      mt: { xs: 0, md: 3 },
                      mb: { xs: 0, sm: 6, md: 3 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    {' '}
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Correcting an employee’s name or Social Security Number
                        (SSN).
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Fixing incorrect wage or tax withholding amounts.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Correcting retirement plan contributions or fringe
                        benefit reporting.
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>Updating state or local wage/tax information.</Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 0,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Adjusting payroll records after year-end due to errors
                        or amendments.
                      </Box>
                    </li>
                  </Box>
                </Box>
              </Paper>
              {/* <Box
                component={'div'}
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/w-2-usecases-img.webp" />
                  <source srcSet="/assets/images/w-2-usecases-img.png" />
                  <img
                    src="/assets/images/w-2-usecases-img.png"
                    alt="Common Use Cases"
                    className="img-responsive"
                    loading="lazy"
                    width={450}
                    height={450}
                    style={{
                      border: '2px solid rgba(190, 190, 190, 0.3)',
                      borderRadius: 21,
                    }}
                  />
                </picture>
              </Box> */}
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Competitor Comparison: Why Choose TaxZerone{' '}
                <Hidden smDown>
                  {' '}
                  <br />
                </Hidden>
                for W-2/W-2C E-Filing
              </Typography>
              <Box component="div" sx={{ mb: 3, backgroundColor: '#fff' }}>
                <TableContainer sx={{}}>
                  <Table sx={{}} aria-label="Due Date Chart">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: '#ccc' }}>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                          }}
                        >
                          Feature
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: 'left',
                          }}
                        >
                          TaxZerone
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: 'left',
                          }}
                        >
                          Other E-file Platforms
                        </TableCell>
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 200,
                            fontWeight: 600,
                            fontSize: 16,
                            textAlign: 'left',
                          }}
                        >
                          Paper Filing (Manual)
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          IRS-Authorized E-File Provider
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          Yes{' '}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          Varies
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          No
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Form Coverage
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          Supports Form W-2 and W-2C
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          Limited coverage
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not Applicable
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Pricing
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          As low as{' '}
                          <span style={{ fontWeight: 600, fontSize: 15 }}>
                            $0.59 per form
                          </span>{' '}
                          <br />
                          (for 1000+)
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          Higher filing fees, hidden charges
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          Printing, postage & manual costs
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Real-Time Error Validation
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>Automatic validation before IRS submission</Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited checks
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Manual review only
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Bulk Upload
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          Accepts extension files
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited or unavailable
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not possible
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Corrections & Re-file
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>Free corrections for rejected returns</Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Extra charges
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          <Box>Manual corrections, resubmission delays</Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Delivery Options
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          E-delivery & Postal Mailing
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Manual printing & mailing
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Recipient Access Portal
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>
                            <Link
                              href="https://www.zeronevault.com/"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              ZeroneVault
                            </Link>{' '}
                            (Secure & <br />
                            IRS-compliant portal)
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Filing Scheduler
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <DoneIcon
                            sx={{ color: '#1da94a', fontSize: 30, mb: -1 }}
                          />{' '}
                          Schedule filings in advance
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Limited
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not possible
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Reminders
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                            display: 'flex',
                          }}
                        >
                          <DoneIcon
                            sx={{
                              color: '#1da94a',
                              fontSize: 30,
                              mb: -1,
                              mr: 0.5,
                            }}
                          />{' '}
                          <Box>Email reminders sent before IRS deadlines</Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          Not available
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{}}>
                        <TableCell
                          sx={{
                            borderBottom: '1px solid #b2b2b2a6',
                            fontSize: 15,
                            fontWeight: 600,
                          }}
                        >
                          Customer Support
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          U.S. based support
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          {' '}
                          Limited or email-only
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: 'left',
                            borderBottom: '1px solid #b2b2b2a6',
                          }}
                        >
                          <CloseIcon
                            sx={{ color: '#dc3545', fontSize: 30, mb: -1.2 }}
                          />{' '}
                          None
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Ready to eFile Your Wage Tax Form?
        </Typography>
        <Typography
          variant="body1"
          color="white"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mb: 2,
          }}
        >
          E-file today and get it securely submitted to the IRS in minutes!
        </Typography>

        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=wagestax`}
          >
            E-File Now
          </Button>
        </Box>
      </Box>

      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What is Form W-2?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Employers use{' '}
                    <Link
                      href="/information-returns/efile-irs-form-w2/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form W-2
                    </Link>{' '}
                    to report wages, tips, and other compensation paid to
                    employees. It also reports the federal, state, and other
                    taxes withheld during the tax year.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Who needs to file Form W-2?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Every employer who pays wages to employees must{' '}
                    <Link
                      href="/information-returns/efile-irs-form-w2/"
                      sx={{ color: '#0202ff' }}
                    >
                      file Form W-2
                    </Link>{' '}
                    for each employee and send a copy to both the IRS and the
                    employee.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What is Form W-2c?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    <Link
                      href="/information-returns/efile-irs-form-w2-c/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form W-2c
                    </Link>{' '}
                    is filed by employers to correct inaccurate details in the
                    wage and tax information they reported to employees and the
                    IRS.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Can I file multiple W-2 or W-2c forms at once?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    <span style={{ fontWeight: 600 }}> Yes</span> , you can file
                    multiple{' '}
                    <Link
                      href="/information-returns/efile-irs-form-w2/"
                      sx={{ color: '#0202ff' }}
                    >
                      W-2
                    </Link>{' '}
                    or{' '}
                    <Link
                      href="/information-returns/efile-irs-form-w2-c/"
                      sx={{ color: '#0202ff' }}
                    >
                      W-2c
                    </Link>{' '}
                    forms at once. TaxZerone supports bulk filing which allows
                    you to submit multiple forms in a single process.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. How can I distribute employee copies of W-2 or W-2c with
                  TaxZerone?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    You can distribute employee copies of W-2 or W-2c instantly
                    via <span style={{ fontWeight: 600 }}> ZeroneVault </span>{' '}
                    or have them delivered by postal mail.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. Which states require W-2 filing and its deadline?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mb: 1 }}>
                      These are the states that require W-2 state filing, and
                      their deadline is:
                    </Typography>
                    <Box component="div" sx={{ mb: 2 }}>
                      <TableContainer sx={{ border: '1px solid #828282' }}>
                        <Table sx={{}} aria-label="Due Date Chart">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: '#ccc' }}>
                              <TableCell
                                sx={{
                                  color: '#444',
                                  width: 300,
                                  textAlign: 'center',
                                }}
                              >
                                State
                              </TableCell>

                              <TableCell
                                sx={{
                                  color: '#444',
                                  width: 300,
                                  textAlign: 'center',
                                }}
                              >
                                Deadline
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <TableRow sx={{}}>
                              <TableCell>
                                Alabama (AL),Arizona (AZ), Arkansas (AR)
                                ,Colorado (CO), Connecticut (CT), Delaware
                                (DE),District of Columbia (DC) , Georgia
                                (GA),Hawaii (HI), Idaho (ID), Illinois (IL),
                                Indiana (IN), Kansas (KS), Kentucky (KY),
                                Louisiana (LA), Maine (ME) ,Maryland
                                (MD),Massachusetts (MA) ,Michigan (MI),Minnesota
                                (MN),Mississippi (MS),Missouri (MO),Montana
                                (MT),Nebraska (NE), New Mexico (NM) , North
                                Carolina (NC), North Dakota (ND) ,Ohio
                                (OH),Oklahoma (OK), Oregon (OR) ,Pennsylvania
                                (PA),Rhode Island (RI) , South Carolina (SC),
                                Utah (UT) ,Vermont (VT),Virginia (VA),West
                                Virginia (WV),Wisconsin (WI){' '}
                              </TableCell>
                              <TableCell
                                sx={{
                                  textAlign: 'center',
                                  fontWeight: 600,
                                  fontSize: 16,
                                }}
                              >
                                January 31{' '}
                              </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                              <TableCell>Iowa (IA), New Jersey (NJ)</TableCell>
                              <TableCell
                                sx={{
                                  textAlign: 'center',
                                  fontWeight: 600,
                                  fontSize: 16,
                                }}
                              >
                                February 15{' '}
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid size={12} sx={{ borderTop: '1px solid #ccc' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                mt: 1,
                textAlign: 'center',
              }}
            >
              New here?
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 22, md: 20, sm: 18, xs: 18 },
                fontWeight: 600,
                mb: 3,
                mt: 1,
                textAlign: 'center',
              }}
            >
              Get the support you need.
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Link href="/resources/" sx={{ textDecoration: 'none' }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  Resources
                </Typography>
                <Typography variant="body1">
                  Access easy-to-follow guides and tips to simplify filing your
                  wage tax forms, so you can stay compliant without the stress.
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Link
              href="https://blog.taxzerone.com/"
              target="_blank"
              sx={{ textDecoration: 'none' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  Blogs
                </Typography>
                <Typography variant="body1">
                  Keep up with the latest IRS updates, filing deadlines, and
                  strategies to make sure your wage tax forms are filed
                  accurately and on time
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Link
              href="https://support.taxzerone.com/"
              target="_blank"
              sx={{ textDecoration: 'none' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  Support Article
                </Typography>
                <Typography variant="body1">
                  Not sure where to begin? Our Support articles will guide you
                  through the wage tax forms filing process with clear answers.
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid size={12} sx={{ mt: 6, borderTop: '1px solid #ccc' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 1,
                mt: 3,
                textAlign: 'center',
              }}
            >
              Still have questions about Wage Tax Forms?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                fontWeight: 400,
                mb: 3,
                mt: 1,
                textAlign: 'center',
              }}
            >
              Reach out to our friendly support team for all your Queries.
            </Typography>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6, md: 4 }}
            sx={{
              mb: 0,
              '& :hover': {
                color: '#0202ff',
              },
            }}
          >
            <Link href="mailto:support@taxzerone.com" underline="none">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Box>
                  <picture>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Email Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  support@taxzerone.com
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6, md: 4 }}
            sx={{
              mb: 0,
              '& :hover': {
                color: '#0202ff',
              },
            }}
          >
            <Link href="tel:+14084447120" underline="none">
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  transition: 'all 0.3s ease 0s',
                  backgroundColor: '#f0f2f9',
                  '&:hover': {
                    cursor: 'pointer',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                  },
                }}
              >
                <Box>
                  <picture>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Email Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                    textAlign: 'center',
                  }}
                >
                  (408) 444-7120
                </Typography>
              </Paper>
            </Link>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6, md: 4 }}
            sx={{
              mb: 0,
              // '& :hover': {
              //   color: '#0202ff',
              // },
            }}
          >
            <Paper
              variant="outlined"
              sx={{
                p: 3,
                py: 3,
                textAlign: 'center',
                borderWidth: 2,
                borderColor: 'transparent',
                borderRadius: 5,
                height: '100%',
                transition: 'all 0.3s ease 0s',
                backgroundColor: '#f0f2f9',
                // '&:hover': {
                //   cursor: 'pointer',
                //   boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                // },
              }}
            >
              <Box>
                <picture>
                  <source
                    srcSet="/assets/images/chat-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/chat-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/chat-icon.png"
                    alt="Email Support"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                  textAlign: 'center',
                }}
              >
                Chat Support
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default WageTaxForms;
